export default "__VITE_ASSET__C1IJ6z4r__"